import { isNil } from 'lodash'

import { isStringEmpty } from '@/utils/general'

export const POWER_BI_AZURE_PERMISSIONS_SCOPE = [
  'https://graph.microsoft.com/offline_access',
  'https://analysis.windows.net/powerbi/api/Workspace.Read.All',
  'https://analysis.windows.net/powerbi/api/Dataset.Read.All'
].join(' ')
export const POWER_BI_AZURE_POPUP_NAME = 'powerBiAzurePopup'
export const POWER_BI_KEYS = {
  CLIENT_ID: 'clientId',
  REDIRECT_URI: 'redirectUri',
  SCOPE: 'scope',
  STATE: 'state'
}

/**
 * Build the Microsoft identity platform (Azure AD) OAuth2 authorization URL for Power BI consent.
 *
 * @param {Object} options
 * @param {string} options.clientId - Azure app (client) id.
 * @param {string} options.redirectUri - Redirect URI configured for the Azure app.
 * @param {string} options.scope - Space-delimited OAuth scopes.
 * @param {string} options.state - Opaque state used to correlate request/response.
 * @returns {string} Fully qualified authorization URL.
 * @throws {Error} If any required option key is missing.
 */
export const generatePowerBiAuthUrl = (options = {}) => {
  const requiredKeys = Object.values(POWER_BI_KEYS)
  const missingKeys = requiredKeys.filter(key => isNil(options[key]) || isStringEmpty(options[key]))
  if (missingKeys.length > 0) {
    throw new Error(`Missing required keys: ${missingKeys.join(', ')}`)
  }

  const url = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize')
  url.searchParams.set('client_id', options[POWER_BI_KEYS.CLIENT_ID])
  url.searchParams.set('prompt', 'consent')
  url.searchParams.set('redirect_uri', options[POWER_BI_KEYS.REDIRECT_URI])
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('scope', options[POWER_BI_KEYS.SCOPE])
  url.searchParams.set('state', options[POWER_BI_KEYS.STATE])

  return url.toString()
}
